import { useQuery } from '@tanstack/react-query';
import { instructionApi } from '@ps/api-client/console';
import { Empty, ErrorState, Loading } from '@ps/ui-kit/components/states';
import { dateTime, tableAmount } from '@ps/ui-kit/lib/format';
import { LinkRow, stop, Table } from '@ps/ui-kit/components/table';

// G-21: payments whose rail outcome is unknown (no confirmation after a timeout). Funds stay reserved and nothing is
// resent; Operations (admin) or the CO open each one and record what reconciliation with the partner showed.

export function ReconcileList({ app, onOpen }: { app: 'admin' | 'console'; onOpen: (id: string) => void }) {
  const q = useQuery({ queryKey: ['reconcile', app], queryFn: () => instructionApi(app).byState('UNKNOWN') });
  if (q.isPending) return <Loading />;
  if (q.error) return <ErrorState message="We couldn't load the payments to reconcile." onRetry={() => void q.refetch()} />;
  if (!q.data.items.length) return <Empty title="Nothing to reconcile">Every payment sent to the partner has a confirmed outcome.</Empty>;
  return (
    <Table>
      <thead>
        <tr><th>URN</th><th>Customer</th><th>Beneficiary</th><th className="text-right">Amount</th>
          <th>Instructed</th><th>Unknown since</th></tr>
      </thead>
      <tbody>
        {q.data.items.map(i => (
          <LinkRow key={i.id} onOpen={() => onOpen(i.id)}>
            <td><button className="font-mono font-semibold text-tick-ink hover:underline" onClick={stop(() => onOpen(i.id))}>{i.urn}</button></td>
            <td>{i.customerName}<span className="block text-xs text-ink-3">{i.customerReference}</span></td>
            <td>{i.beneficiaryName}</td>
            <td className="text-right tabular">{tableAmount(i.srcAmountMinor, i.srcCcy)}</td>
            <td className="whitespace-nowrap">{dateTime(i.instructedAt)}</td>
            <td className="whitespace-nowrap text-bad">{dateTime(i.updatedAt)}</td>
          </LinkRow>
        ))}
      </tbody>
    </Table>
  );
}
